import { z } from "zod/v4";

export const SUPPORT_MESSAGE_MAX_LENGTH = 50_000;
export const SUPPORT_SUBJECT_MAX_LENGTH = 255;

// Legacy plain callers remain accepted during rollout; the requester email comes from authentication.
export const PostSupportTicketRequestBodySchema = z
  .object({
    name: z.string().trim().min(1).max(401),
    subject: z.string().trim().min(1).max(SUPPORT_SUBJECT_MAX_LENGTH),
    description: z.string().min(1).max(SUPPORT_MESSAGE_MAX_LENGTH),
    descriptionFormat: z.enum(["plain", "html"]).optional(),
    experienceIds: z.array(z.string().uuid()).optional(),
    notAboutExperience: z.boolean().optional(),
    attachments: z
      .array(z.object({ key: z.string().min(1).max(1024) }))
      .max(5)
      .optional(),
    pageUrl: z.string().max(2048).optional(),
    testType: z.string().optional(),
  })
  .superRefine((body, ctx) => {
    const ids = body.experienceIds ?? [];
    const explicit =
      body.experienceIds !== undefined || body.notAboutExperience !== undefined;
    if (explicit && (ids.length === 0) === !body.notAboutExperience) {
      ctx.addIssue({
        code: "custom",
        path: ["experienceIds"],
        message:
          "Select relevant experiences or choose General question or inquiry.",
      });
    }
    if (!explicit && !body.testType) {
      ctx.addIssue({
        code: "custom",
        path: ["experienceIds"],
        message:
          "Select relevant experiences or choose General question or inquiry.",
      });
    }
    if (new Set(ids).size !== ids.length) {
      ctx.addIssue({
        code: "custom",
        path: ["experienceIds"],
        message: "Experience selections must be unique.",
      });
    }
    const keys = body.attachments?.map((file) => file.key) ?? [];
    if (new Set(keys).size !== keys.length) {
      ctx.addIssue({
        code: "custom",
        path: ["attachments"],
        message: "Attachment selections must be unique.",
      });
    }
  });
export type PostSupportTicketRequestBodyType = z.infer<
  typeof PostSupportTicketRequestBodySchema
>;
export const PostSupportTicketResponseBodySchema = z.object({ id: z.string() });
export type PostSupportTicketResponseBodyType = z.infer<
  typeof PostSupportTicketResponseBodySchema
>;
